import { Contact } from "./contact.model";
import { Location } from "./location.model";
export class BaseAccomodation {

    constructor(
        public name? : string,
        public contactDto? : Contact,
        public locationDto? : Location,  
    ) {}
}